import { LoaderSize } from '../loaders';
import { MibThumbnailBusyIcon, MibThumbnailSize } from './thumbnail.models';

/** What one size gives the thumbnail. */
export interface ThumbnailSizeConfig {
  /** Classes of the frame. */
  frame: string;
  /** Size of the unavailable icon, and of the busy `refresh` icon. */
  icon: string;
  /** What busy draws when the thumbnail's `busyIcon` is not set. */
  busyIcon: MibThumbnailBusyIcon;
  /** Size of the busy spinner. */
  spinner: LoaderSize;
  /** Whether the busy sentence is written under the mark rather than given as its tooltip. */
  busyCaption: boolean;
}

/** `sm` fits a 36px-tall row; `fill` takes the 28px icon step a card's picture holds. */
export const THUMBNAIL_SIZE: Record<MibThumbnailSize, ThumbnailSizeConfig> = {
  sm: {
    frame: 'relative w-16 shrink-0 aspect-video rounded-mib',
    icon: 'size-4',
    busyIcon: 'refresh',
    spinner: 'sm',
    busyCaption: false,
  },
  fill: { frame: 'absolute inset-0', icon: 'size-7', busyIcon: 'spinner', spinner: 'lg', busyCaption: true },
};
